import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClientsStore from '../../stores/ClientsStore'
import { Form, Header } from 'semantic-ui-react'
import Input from '../Forms/Input'

class AddressInformation extends Component {
  static propTypes = {
    clientsStore: PropTypes.instanceOf(ClientsStore),
    canEdit: PropTypes.bool
  }

  static defaultProps = {
    canEdit: false
  }

  render () {
    const { clientsStore, canEdit } = this.props
    return (
      <>
        <Header as='h2'>
          Informations Adresse
        </Header>
        <Form>
          <Form.Group widths='equal'>
            <Input name='client.address.route' store={clientsStore} label='Adresse' readOnly={!canEdit} />
            <Input name='client.address.room' store={clientsStore} label='Suite' readOnly={!canEdit} />
          </Form.Group>
          <Form.Group widths='equal'>
            <Input name='client.address.city' store={clientsStore} label='Ville' readOnly={!canEdit} />
            <Input name='client.address.province' store={clientsStore} label='Province' readOnly={!canEdit} />
          </Form.Group>
          <Form.Group widths='equal'>
            <Input name='client.address.country' store={clientsStore} label='Pays' readOnly={!canEdit} />
            <Input name='client.address.postal_code' store={clientsStore} label='Code postale' readOnly={!canEdit} />
          </Form.Group>
        </Form>
      </>
    )
  }
}

export default AddressInformation
